import { arkandhaGeoserverUrl } from '@/env';
import GeosService from '@/services/GeosService.js';

const geos = {
  namespaced: true,

  state: {
    // estado que almacena los sistermas disponibles para colombia
    coordinateSystems: [
      {
        name: 'Bogota 1975',
        code: 'EPSG:4218',
        type: 'geo',
        proj4: '+proj=longlat +ellps=intl +towgs84=307,304,-318,0,0,0,0 +no_defs +type=crs',
      },
      {
        name: 'MAGNA-SIRGAS',
        code: 'EPSG:4686',
        type: 'geo',
        proj4: '+proj=longlat +ellps=GRS80 +no_defs +type=crs',
      },
      {
        name: 'WGS 84',
        code: 'EPSG:4326',
        type: 'geo',
        proj4: '+proj=longlat +datum=WGS84 +no_defs +type=crs',
      },
      {
        name: 'WGS 84 / Pseudo-Mercator',
        code: 'EPSG:3857',
        type: 'proj',
        proj4: '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs',
      },
      {
        name: 'MAGNA-SIRGAS 2018 / Origen-Nacional',
        code: 'EPSG:9377',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4 +lon_0=-73 +k=0.9992 +x_0=5000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
      },
      {
        name: 'Bogota 1975 / Colombia Bogota zone',
        code: 'EPSG:21897',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.59904722222222 +lon_0=-74.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs +type=crs',
      },
      {
        name: 'Bogota 1975 / Colombia East',
        code: 'EPSG:21899',
        type: 'proj',
        proj: '+proj=tmerc +lat_0=4.59904722222222 +lon_0=-68.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=221.899,274.136,-397.554,1.361573e-05,-2.174431e-06,-1.36241e-05,-2.199943 +units=m +no_defs +type=crs',
      },
      {
        name: 'Bogota 1975 /  Colombia East Central zone',
        code: 'EPSG:21898',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.59904722222222 +lon_0=-71.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs +type=crs',
      },
      {
        name: 'Bogota 1975 / Colombia West zone',
        code: 'EPSG:21896',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.59904722222222 +lon_0=-77.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs +type=crs',
      },
      {
        name: 'Bogota 1975 / UTM zone 18N',
        code: 'EPSG:21818',
        type: 'proj',
        proj4: '+proj=utm +zone=18 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs +type=crs'
      },
      {
        name: 'MAGNA-SIRGAS / Colombia Bogota zone',
        code: 'EPSG:3116',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.596200416666666 +lon_0=-74.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs")'
      },
      {
        name: 'MAGNA-SIRGAS / Colombia East Central zone',
        code: 'EPSG:3117',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.596200416666666 +lon_0=-71,077507916666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      },
      {
        name: 'MAGNA-SIRGAS / Colombia East zone',
        code: 'EPSG:3118',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.59620041666667 +lon_0=-68.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
      },
      {
        name: 'MAGNA-SIRGAS / Colombia Far West zone',
        code: 'EPSG:3114',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.59620041666667 +lon_0=-80.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
      },
      {
        name: 'MAGNA-SIRGAS / Colombia West zone',
        code: 'EPSG:3115',
        type: 'proj',
        proj4: '+proj=tmerc +lat_0=4.596200416666666 +lon_0=-77.07750791666666 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
      },
      {
        name: '	WGS 84 / UTM zone 17N',
        code: 'EPSG:32617',
        type: 'proj',
        proj4: '+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs +type=crs',
      },
      {
        name: '	WGS 84 / UTM zone 18N',
        code: 'EPSG:32618',
        type: 'proj',
        proj4: '+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs +type=crs',
      },
      {
        name: '	WGS 84 / UTM zone 18S',
        code: 'EPSG:32718',
        type: 'proj',
        proj4: '+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs +type=crs',
      },
      {
        name: '	WGS 84 / UTM zone 19N',
        code: 'EPSG:32619',
        type: 'proj',
        proj4: '+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs +type=crs',
      },
      {
        name: '	WGS 84 / UTM zone 19S',
        code: 'EPSG:32719',
        type: 'proj',
        proj4: '+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs +type=crs'
      },
    ],
    // nombre por defecto de la capa de predios catastrales
    defaultCadastralLayer: 'Predios catastro 2017(Junio)',
    // capas base para los mapas leaflet
    layers: [
      {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        name: 'Open Street',
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        type: 'base',
        transparent: false,
      },
      {
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        name: 'Esri WorldImagery',
        attribution:
          'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        type: 'base',
        transparent: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2017(Junio)',
        layers: 'predios_totales_2017_06',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2021(Diciembre)',
        layers: 'predios_totales_2021_12',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2023(Marzo)',
        layers: 'predios_totales_2023_03',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2024(Enero)',
        layers: 'predios_totales_2024_01',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2024(Noviembre)',
        layers: 'predios_totales_2024_11',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2025(Octubre)',
        layers: 'predios_totales_2025_10',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Predios catastro 2026(Mayo)',
        layers: 'predios_totales_2026_05',
        attribution: 'ARkandha © 2026',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Cundinamarca 2023(Abril)',
        layers: 'cundinamarca_2023_04',
        attribution: 'ARkandha © 2025',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
      {
        url: arkandhaGeoserverUrl,
        name: 'Antioquia 2026(Febrero)',
        layers: 'antioquia_2026_02',
        attribution: 'ARkandha © 2026',
        type: 'overlay',
        transparent: true,
        format: 'image/png',
        visible: false,
      },
    ],
    // estado con los marcadores
    markers: {
      'Colombia': {
        zoom: 5,
        lat: 3.95399,
        lng: -73.29251
      }
    }
  },

  actions: {
    async getGeojsonFromShapefile({ commit }, { file, layer }) {
      /**
       * Accion para obetener el reporte en word con la gestión de los desarrollos
       *
       * @param {Object} context datos del modulo
       * @param {Object} reportData datos del reporte
       *
       * @returns {Object} Respuesta con elementos
       * @example
       * $store.dispatch('geos/getGeojsonFromShapefile', {
       *   file: File,
       *   layer: <nombre_capa>
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {        
        const token = localStorage.getItem('token');
        const response = await GeosService.getGeojsonFromShapefile(file, layer, token);
        const fileContent = response.data;
        // const fileContent = JSON.parse(data.getGeojsonFromShapefile);
        commit('ui/SHOW_ALERT', {
          alertMessage: 'Se ha generado el geojson correctamente',
          alertType: 'success'
        }, { root: true });
        return { obtained: true, content: fileContent };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrió un error al generar el geojson: ${error}`,
          alertType: 'error'
        }, { root: true });
        return { obtained: false };
      }
    },
    async inspectKmzFile({ commit }, { file }) {
      /**
       * Accion para obetener la informacion d elas capas de un archivo KML
       *
       * @param {Object} context datos del modulo
       * @param {Object} reportData datos del reporte
       *
       * @returns {Object} Respuesta con elementos
       * @example
       * $store.dispatch('core/inspectKmzFile', {
       *   file: File,
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {
        const token = localStorage.getItem('token');
        const response = await GeosService.inspectKmzFile(file, token);
        const fileContent = response.data;
        return { obtained: true, content: fileContent };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrió un error al inspeccionar el KMZ: ${error}`,
          alertType: 'error'
        }, { root: true });
        return { obtained: false };
      }
    },
    async getGeojsonFromKmz({ commit }, { file, layer }) {
      /**
       * Accion para obetener el reporte en word con la gestión de los desarrollos
       *
       * @param {Object} context datos del modulo
       * @param {Object} reportData datos del reporte
       *
       * @returns {Object} Respuesta con elementos
       * @example
       * $store.dispatch('geos/getGeojsonFromKmz', {
       *   file: File,
       *   layer: <nombre_capa>
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {        
        const token = localStorage.getItem('token');
        const response = await GeosService.getGeojsonFromKmz(file, layer, token);
        const fileContent = response.data;
        // const fileContent = JSON.parse(data.getGeojsonFromShapefile);
        commit('ui/SHOW_ALERT', {
          alertMessage: 'Se ha generado el geojson correctamente',
          alertType: 'success'
        }, { root: true });
        return { obtained: true, content: fileContent };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrió un error al generar el geojson: ${error}`,
          alertType: 'error'
        }, { root: true });
        return { obtained: false };
      }
    },
    async inspectGpxFile({ commit }, { file }) {
      /**
       * Accion para obetener la informacion d elas capas de un archivo GPX
       *
       * @param {Object} context datos del modulo
       * @param {Object} reportData datos del reporte
       *
       * @returns {Object} Respuesta con elementos
       * @example
       * $store.dispatch('core/inspectGpxFile', {
       *   file: File,
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {
        const token = localStorage.getItem('token');
        const response = await GeosService.inspectGpxFile(file, token);
        const fileContent = response.data;
        return { obtained: true, content: fileContent };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrió un error al inspeccionar el GPX: ${error}`,
          alertType: 'error'
        }, { root: true });
        return { obtained: false };
      }
    },
    async getGeojsonFromGpx({ commit }, { file, layer }) {
      /**
       * Accion para obetener el reporte en word con la gestión de los desarrollos
       *
       * @param {Object} context datos del modulo
       * @param {Object} reportData datos del reporte
       *
       * @returns {Object} Respuesta con elementos
       * @example
       * $store.dispatch('geos/getGeojsonFromGpx', {
       *   file: File,
       *   layer: <nombre_capa>
       * })
       * @author Luis Merizalde <luis.merizalde@arcerojas.com>
       */
      try {        
        const token = localStorage.getItem('token');
        const response = await GeosService.getGeojsonFromGpx(file, layer, token);
        const fileContent = response.data;
        // const fileContent = JSON.parse(data.getGeojsonFromShapefile);
        commit('ui/SHOW_ALERT', {
          alertMessage: 'Se ha generado el geojson correctamente',
          alertType: 'success'
        }, { root: true });
        return { obtained: true, content: fileContent };
      } catch (error) {
        commit('ui/SHOW_ALERT', {
          alertMessage: `Ocurrió un error al generar el geojson: ${error}`,
          alertType: 'error'
        }, { root: true });
        return { obtained: false };
      }
    },
  },

  getters: {
    getProj4: (state) => (code) => {
      return state.coordinateSystems.filter((x) => x.code === code)[0].proj4;
    },
    // getter para obtener las capas base + un capa capastral
    getOneCadastral: (state) => (base) => {
      return state.layers.filter((x) => x.type === 'base' || x.layers === base);
    }
  }
};

export default geos;
